import { defineComponent, createBlock, openBlock } from 'vue';
import _sfc_main$1 from './basler-components.es228.js';
/* empty css                        */

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TilesBlock",
  props: {
    tiles: {}
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$1, {
        class: "tiles-block",
        tiles: props.tiles
      }, null, 8, ["tiles"]);
    };
  }
});

export { _sfc_main as default };
